export enum StatusAgendamentoEnum {
  ABERTO = "ABERTO",
  AGUARDANDO_PAGAMENTO = "AGUARDANDO_PAGAMENTO",
  AGENDADO = "AGENDADO",
  FINALIZADO = "FINALIZADO",
  INICIADO = "INICIADO",
  CANCELADO = "CANCELADO",
  PAGO = "PAGO",
  REEMBOLSADO = "REEMBOLSADO",
}
